<template>
  <div class="canteenInfo">
    <el-form ref="educationForm" :model="educationForm" class="educationForm" label-width="165px" label-position="left" :rules="rule_data" :hide-required-asterisk=true>
      <el-form-item prop="qualificationProofs">
        <template slot="label"><div><span class="red">*</span>机构资质证明</div><span>(最少1张，最多5张)</span></template>
        <multi-upload :value="educationForm.qualificationProofs" valueName="qualificationProofs" :limit="5" :otherData="{type:'qualificationProofs'}" @uploaded="multiUploaded" @delete="multiDelete"></multi-upload>
      </el-form-item>
      <el-divider></el-divider>
      <!-- <el-form-item prop="schoolLicenseProofs">
        <template slot="label"><div><span class="red">*</span>办学许可证</div><span>(最少1张，最多5张)</span></template>
        <multi-upload :value="educationForm.schoolLicenseProofs" valueName="schoolLicenseProofs" :limit="5" :otherData="{type:'schoolLicenseProofs'}"  @uploaded="multiUploaded" @delete="multiDelete"></multi-upload>
      </el-form-item> -->
      <el-divider></el-divider>
      <el-form-item prop="storeTenancyProofs">
        <template slot="label"><div><span class="red">*</span>门店租赁相关证明</div><span>(最少1张，最多5张)</span></template>
        <multi-upload :value="educationForm.storeTenancyProofs" valueName="storeTenancyProofs" :limit="5" :otherData="{type:'storeTenancyProofs'}"  @uploaded="multiUploaded" @delete="multiDelete"></multi-upload>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item prop="storeDoorPhotos">
        <template slot="label"><div><span class="red">*</span>门头照</div><span>(最少1张，最多5张)</span></template>
        <multi-upload :value="educationForm.storeDoorPhotos" valueName="storeDoorPhotos" :limit="5" :otherData="{type:'storeDoorPhotos'}"  @uploaded="multiUploaded" @delete="multiDelete"></multi-upload>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import multiUpload from '@/components/upload/multiUpload'
export default {
  components: {
    multiUpload
  },
  props: {
    educationForm: {
      type: Object,
      default: function () {
        return {
          qualificationProofs: '',
          // schoolLicenseProofs: '',
          storeTenancyProofs: '',
          storeDoorPhotos: ''
        }
      }
    }
  },
  data () {
    return {
      rule_data: {
        qualificationProofs: [{
          required: true,
          message: '请上传机构资质证明',
          trigger: 'blur'
        }],
        // schoolLicenseProofs: [{
        //   required: true,
        //   message: '请上传办学许可证',
        //   trigger: 'change'
        // }],
        storeTenancyProofs: [{
          required: true,
          message: '请上传门店租赁相关证明',
          trigger: 'change'
        }],
        storeDoorPhotos: [{
          required: true,
          message: '请上传门头照',
          trigger: 'change'
        }]
      }
    }
  },
  methods: {
    // 批量上传成功回调
    multiUploaded (data) {
      const that = this
      if (!that.educationForm[data.valueName]) {
        that.educationForm[data.valueName] = data.path
      } else {
        that.educationForm[data.valueName] += ',' + data.path
      }
      this.$refs.educationForm.validateField(data.valueName)
      this.$emit('change', this.educationForm)
    },
    // 批量上传删除某一张回调
    multiDelete (data) {
      if (this.educationForm[data.valueName].indexOf(',' + data.path) >= 0) {
        this.educationForm[data.valueName] = this.educationForm[data.valueName].replace(',' + data.path, '')
      } else {
        this.educationForm[data.valueName] = this.educationForm[data.valueName].replace(data.path, '')
      }
      if (this.educationForm[data.valueName].indexOf(',') === 0) {
        this.educationForm[data.valueName] = this.educationForm[data.valueName].substring(1)
      };
      this.$emit('change', this.educationForm)
    }
  }
}
</script>

<style>
  .red {
    color:red;
  }
  .canteenTooltip{
    background: #515b62;
    color: #606266;
    line-height: 20px;
    border-radius: 20px;
  }
</style>
